import { FullUserBoundary } from '@ui/general';
import { LinkSalesforce } from './LinkSalesforce';
import { LinkSalesforceSandbox } from './LinkSalesforceSandbox';
import { OrganizationsTable } from './OrganizationsTable';
import React from 'react';
import { SETTINGS_ORGANIZATION_COPY } from '@sonar-software/sonar-ts-constants';
import { SonarCard } from '@ui/general/SonarCard';
import { Space } from 'antd';
export const OrganizationsList = () => React.createElement(SonarCard, { extra: React.createElement(FullUserBoundary, null,
        React.createElement(Space, null,
            React.createElement(LinkSalesforceSandbox, { key: 'link-sandbox' }),
            React.createElement(LinkSalesforce, { key: 'link-org' }))), id: 'organizations-list', noSpacing: true, title: SETTINGS_ORGANIZATION_COPY.CONNECTED_ORGANIZATIONS },
    React.createElement(OrganizationsTable, null));
